import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environmentBase } from '../environments/environment.base';
import {
  NotificationPreferences,
  SaveNotificationPreferencesRequest,
  normalizeNotificationPreferences
} from '../models/notification-preferences.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationPreferencesService {
  private http = inject(HttpClient);
  private readonly apiUrl = environmentBase.apiUrl;

  getByMCode(mCode: string) {
    const params = new HttpParams().set('mCode', mCode);
    return this.http
      .get<Partial<NotificationPreferences>>(`${this.apiUrl}/me/notifications`, { params })
      .pipe(map(dto => normalizeNotificationPreferences(dto)));
  }

  save(request: SaveNotificationPreferencesRequest) {
    return this.http.post<void>(`${this.apiUrl}/me/notifications`, request);
  }
}
